import { aboutData } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            {aboutData.title}
          </h2>
          <div className="mt-6 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-6 text-sm md:text-base text-foreground-700 leading-relaxed">
            {aboutData.description}
          </p>
        </div>
      </div>
    </section>
  );
}